<template>
  <div>
    <div @click="download()" class="ml-5">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="primary" dark v-bind="attrs" v-on="on">
            mdi-download
          </v-icon>
        </template>
        <span>Download Image</span>
      </v-tooltip>
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
export default {
  props: ["imgSrc"],
  data() {
    return {};
  },
  methods: {
    download() {
      let splittedURl = this.imgSrc.split("amazonaws.com/");
      if (!splittedURl[1]) {
        return;
      }
      window.open(`${config.BASE_URL}api/s3Upload?file_name=${splittedURl[1]}`);
    },
  },
};
</script>
<style >
</style>